module.exports = __webpack_public_path__ + "media/shield.1a77a0be.mp3";